export default {
    name: "LoginPage",
    setup(){
        
    }
}